import { Form } from 'react-final-form';
import { Close } from '@mui/icons-material';
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import classnames from 'classnames';

import StyledDialog from '@components/Modal/StyledDialog';
import getKebabFromString from '@utils/getKebabFromString';

import { IModalFormProps } from './ModalForm.interface';

function ModalForm<T>({
  children,
  leftActionTitle,
  onClose,
  onExited,
  onLeftAction,
  open,
  rightActionTitle,
  rightActionIcon,
  className,
  title,
  icon,
  showCloseButton = false,
  formId,
  ...formProps
}: IModalFormProps<T>) {
  const modalClasses = classnames('modal', 'modal-form', className);

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby={getKebabFromString(title)}
      aria-describedby={getKebabFromString(title)}
      className={modalClasses}
      TransitionProps={{ onExited }}
      PaperProps={{ className: 'modal__paper' }}
    >
      {showCloseButton && (
        <IconButton className="modal__close-button" onClick={onClose}>
          <Close />
        </IconButton>
      )}

      {title && (
        <DialogTitle id={getKebabFromString(title)} className="modal__title">
          {icon}
          {title}
        </DialogTitle>
      )}

      <Form {...formProps}>
        {props => (
          <>
            <DialogContent className="modal__content">
              {typeof children === 'function' && children(props)}
            </DialogContent>

            <DialogActions className="modal__actions">
              {onLeftAction && (
                <Button
                  onClick={onLeftAction}
                  variant="text"
                  className="modal__action modal__action_left"
                >
                  {leftActionTitle}
                </Button>
              )}

              <Button
                type="submit"
                disabled={props.hasValidationErrors || props.submitting}
                variant="contained"
                className="modal__action modal__action_right"
                form={formId}
              >
                {props.submitting ? (
                  <CircularProgress
                    className="modal__action-loader"
                    color="inherit"
                    size={16}
                    thickness={5}
                  />
                ) : (
                  rightActionIcon
                )}
                {rightActionTitle}
              </Button>
            </DialogActions>
          </>
        )}
      </Form>
    </StyledDialog>
  );
}

export default ModalForm;
